import {DefaultHeightParams} from "../types/record-table-container.types";

export const defaultHeightParams: DefaultHeightParams = {
  minHeightSizeTable: 170,
  maxHeightSizeTable: 330,
  defaultHeightRow: 50,
  defaultHeightHeader: 70
}
